/**
 * Use invariant() to assert state which your program assumes to be true otherwise an error
 * will be throw during ONLY either in `development` OR `test` mode
 *
 * @param {Boolean} condition
 * @param {String} [message='Error'] optional message parameter defaults to `Error`
 * @returns {void|Error}
 */
export function invariant(condition: any, message = 'Error'): asserts condition {
  if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test') {
    if (!condition) {
      throw new Error(message);
    }
  }
}
